import Link from 'next/link';
import React from 'react';
import StyledLink from './StyledLink';

export type StyledNextLinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
};

export default function StyledNextLink({
  href,
  children,
  className,
}: StyledNextLinkProps) {
  return (
    <Link href={href} passHref>
      <StyledLink className={className}>{children}</StyledLink>
    </Link>
  );
}
